<section class="login-shell">
	<div class="bg-shape bg-shape-left"></div>
	<div class="bg-shape bg-shape-right"></div>

	<div class="login-card">
		<!-- <div class="brand-pill">
			<i class="pi pi-shield"></i>
			<span>PostNord Secure Access</span>
		</div> -->

		<h1>Welcome to CINT Statistics</h1>
		<p class="subtitle">
			Sign in with your Microsoft account to continue to the dashboard.
		</p>

		<div class="info-grid">
			<div class="info-item">
				<i class="pi pi-check-circle"></i>
				<span>Track daily metrics and performance</span>
			</div>
			<div class="info-item">
				<i class="pi pi-check-circle"></i>
				<span>Real-time data insights and reporting</span>
			</div>
			<!-- <div class="info-item">
				<i class="pi pi-sync"></i>
				<span>Automatic token refresh flow</span>
			</div> -->
		</div>

		<button
			pButton
			type="button"
			class="signin-btn"
			[label]="isSigningIn ? authButtonLabels.redirecting : authButtonLabels.signIn"
			icon="pi pi-sign-in"
			[loading]="isSigningIn"
			[disabled]="isSigningIn"
			(click)="login()"
		></button>

		<p class="hint">You will be redirected to Microsoft for authentication.</p>
	</div>
</section>

<p-dialog
	header="Access Denied"
	[(visible)]="accessDeniedVisible"
	[modal]="true"
	[closable]="true"
	[draggable]="false"
	[resizable]="false"
	[style]="{ width: 'min(28rem, calc(100vw - 2rem))' }"
>
	<p>{{ accessDeniedMessage }}</p>
	<ng-template pTemplate="footer">
		<button
      pButton
      class="access-denied-btn" label="OK" (click)="onAccessDeniedOk()"></button>
	</ng-template>
</p-dialog>
